import React from 'react'
import { createRoot } from 'react-dom/client'

import { BrowserRouter } from 'react-router-dom'
import { SiteContextProvider } from './context/site-context'

import ScrollToTop from 'components/atoms/ScrollToTop'

import App from './App'

import './index.scss'

const root = createRoot(document.getElementById('root'))
root.render(
  <SiteContextProvider>
    <BrowserRouter>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </BrowserRouter>
  </SiteContextProvider>
)
